"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.completeGroceryItemByKeywordMutationOptions = exports.completeGroceryItemByKeywordMutation = void 0;
const client_1 = require("@apollo/client");
const groceryItems_1 = require("../queries/groceryItems");
exports.completeGroceryItemByKeywordMutation = client_1.gql `
  mutation CompleteGroceryItemByKeyword(
    $keyword: String!
    $complete: Boolean!
  ) {
    completeGroceryItemByKeyword(keyword: $keyword, complete: $complete) {
      ok
    }
  }
`;
exports.completeGroceryItemByKeywordMutationOptions = (variables) => ({
    variables,
    update: store => {
        try {
            const data = store.readQuery({
                query: groceryItems_1.groceryItemsQuery,
            });
            if (data) {
                store.writeQuery({
                    query: groceryItems_1.groceryItemsQuery,
                    data: {
                        __typename: "Query",
                        groceryItems: {
                            __typename: "GroceryItemsResponse",
                            recipes: data.groceryItems.recipes,
                            items: data.groceryItems.items.map(x => x.keyword === variables.keyword
                                ? Object.assign(Object.assign({}, x), { complete: variables.complete }) : x),
                        },
                    },
                });
            }
        }
        catch (_a) { }
    },
});
//# sourceMappingURL=completeGroceryItemByKeyword.js.map